import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'horaMinuto'
})
export class HoraMinutoPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) return '';

		const [horas, minutos] = value.split(':');
		return `${horas}:${minutos}`;
	}
}
